import { Injectable } from '@kaokei/use-vue-service';

/**
 * 整个页面的音视频资源需要集中管理
 *
 * @export
 * @class PlayerManagerService
 */
@Injectable()
export class PlayerManagerService {
  public list = [] as HTMLAudioElement[];

  public add(au: HTMLAudioElement) {
    this.list.push(au);
  }

  public remove(au: HTMLAudioElement) {
    this.list = this.list.filter(item => item !== au);
  }

  public pause(au: HTMLAudioElement) {
    !au.paused && au.pause();
  }

  public stop(au: HTMLAudioElement) {
    this.pause(au);
    au.currentTime = 0;
  }

  public play(au: HTMLAudioElement) {
    if (au.paused) {
      for (const item of this.list) {
        this.stop(item);
      }
      au.play();
    }
  }

  public toggle(au: HTMLAudioElement) {
    if (au.paused) {
      this.play(au);
    } else {
      this.stop(au);
    }
  }
}
